module.exports = __webpack_public_path__ + "img/child.17e98cce.svg";